



































































































































































































































































import VueOptions from '@utils/VueOptions'
import UiList from '@superUI/List/List'
import RequestButton from '@/components/RequestButton'
import Trigger from '@modules/ui/triggers/Trigger'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'
import DropdownFilter from '@ui/Filters/DropdownFilter'
import SponsorSetSelector from '@ui/Campaign/SponsorSetSelector'
import SupplierSelector from '@ui/Campaign/SupplierSelector'

settings =
  name: 'PayoutBoardOfferResourceList'

  components: {
    UiList,
    RequestButton,
    Trigger,
    ResourceList,
    LoadingIndicator,
    DropdownFilter,
    SponsorSetSelector,
    SupplierSelector,
  }

  vue:
    props: ['offers', 'actions', 'filtersOverriden', 'infiniteWrapper', 'options']

    data: ->
      pageNumber: 1

      disabledTarget: false
      scopes: ['accepted']
      q: ''
      sort: []
      target: null

      sortValue: ''
      sortList: [
        { field: 'payout_arc.approved_at', value: 'Approved Date' }
        { field: 'bill.due_date', value: 'Due Date (BILL.com)' }
      ]

      selectedOffers: []
      selectedFilters: []

    computed:
      components: ->
        {
          'payout-board-offer-resource-list-item': () => import('./PayoutBoardOfferResourceListItem')
        }
      title: ->
        @options?.title || 'Payout Board'

      resourceKey: ->
        @options?.resourceKey || 'offers'

      actionsForSponsorSetSelector: ->
        {
          select: @selectSponsorSet,
          unselect: @unselectSponsorSet,
          unselectAll: @unselectAllSponsorSet,
        }
      selectedFilterSponsorSet: ->
        values = [...@target.sponsor_set]
        values

      actionsForSupplierSelector: ->
        {
          select: @selectSupplier,
          unselect: @unselectSupplier,
          unselectAll: @unselectAllSupplier,
        }
      selectedFilterSupplier: ->
        values = [...@target.suppliers]
        values

      selectedFilterDueDate: ->
        [start, end] = @target.due_date
        values = []
        values.push start if start
        values.push end if end
        values

      selectedFilterPaidAt: ->
        [start, end] = @target.paid_at
        values = []
        values.push start if start
        values.push end if end
        values

      selectedFilterStatus: ->
        values = []
        values.push key for key of @target.payout_status when @target.payout_status[key]
        values.push key for key of @target.bill_approval_status when @target.bill_approval_status[key]
        values.push key for key of @target.bill_payment_status when @target.bill_payment_status[key]
        values.push @target.bill_overdue if @target.bill_overdue
        values.push @target.bill_and_app_names_dont_match if @target.bill_and_app_names_dont_match
        values.push @target.bill_and_app_amounts_dont_match if @target.bill_and_app_amounts_dont_match
        values.push @target.payout_bank_account_missing_w9_form if @target.payout_bank_account_missing_w9_form
        values.push @target.payout_bank_account_missing_payment_method if @target.payout_bank_account_missing_payment_method
        values.push @target.payout_bank_account_missing_w9_or_payment_method if @target.payout_bank_account_missing_w9_or_payment_method
        values

      # Workflows

      isPendingApprovalWorkflow: ->
        @objectsAreEqual @target, { ...@target, ...@getPendingApprovalTarget() }

      isApprovedWorkflow: ->
        @objectsAreEqual @target, { ...@target, ...@getApprovedTarget() }

      isOverdueWorkflow: ->
        @objectsAreEqual @target, { ...@target, ...@getOverdueTarget() }

      isAmountsDontMatchWorkflow: ->
        @objectsAreEqual @target, { ...@target, ...@getAmountsDontMatchTarget() }

      # Sorting

      availableSort: ->
        @sortList.filter (sort) =>
          !@sort.find((item) -> item.field is sort.field)

    created: ->
      @target = @getApprovedTarget()
      @selectedFilters = @makeSelectedFilters()

    methods:
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @targetPayload(), { page: @pageNumber })
        @pageNumber += 1

      hiCsvExport: ->
        @actions.csvExport(@targetPayload())

      hiClearFilter: ->
        @clearFilter()
        @hiApplyFilters()

      hiSearchChange: (q = '') ->
        @hiApplyFilters()

      hiApplyFilters: ->
        @selectedFilters = @makeSelectedFilters()
        @$refs.infiniteLoading?.stateChanger?.reset()
        @pageNumber = 1
        @actions.fetchResource(null, @resourceKey, @targetPayload(), { page: @pageNumber })
        @pageNumber += 1

      hiClearSponsorSetFilter: ->
        @target.sponsor_set = []
        @hiApplyFilters()
      selectSponsorSet: (option) ->
        @target.sponsor_set.push option.data
      unselectSponsorSet: (option) ->
        @target.sponsor_set = @target.sponsor_set.filter((sponsor) -> sponsor.domain isnt option.key)
      unselectAllSponsorSet: ->
        @target.sponsor_set = []
      clearSponsorSet: ->
        @target.sponsor_set = []

      hiClearSupplierFilter: ->
        @target.suppliers = []
        @hiApplyFilters()
      selectSupplier: (option) ->
        @target.suppliers.push option.data
      unselectSupplier: (option) ->
        @target.suppliers = @target.suppliers.filter((supplier) -> supplier.id isnt option.key)
      unselectAllSupplier: ->
        @target.suppliers = []
      clearSupplier: ->
        @target.suppliers = []

      hiClearDueDateFilter: ->
        @target.due_date = []
        @hiApplyFilters()

      hiClearPaidAtFilter: ->
        @target.paid_at = []
        @hiApplyFilters()

      hiClearStatusFilter: ->
        @target.payout_status[key] = false for key of @target.payout_status
        @target.bill_approval_status[key] = false for key of @target.bill_approval_status
        @target.bill_payment_status[key] = false for key of @target.bill_payment_status
        @target.bill_overdue = false
        @target.bill_and_app_names_dont_match = false
        @target.bill_and_app_amounts_dont_match = false
        @target.payout_bank_account_missing_w9_form = false
        @target.payout_bank_account_missing_payment_method = false
        @target.payout_bank_account_missing_w9_or_payment_method = false
        @hiApplyFilters()

      clearFilter: ->
        @target = @makeDefaultTarget()

      makeSelectedFilters: ->
        filters = []
        filters.push { name: 'Brand' } if @selectedFilterSponsorSet.length
        filters.push { name: 'Supplier' } if @selectedFilterSupplier.length
        filters.push { name: 'Due date' } if @selectedFilterDueDate.length
        filters.push { name: 'Paid date' } if @selectedFilterPaidAt.length
        filters.push { name: 'Status' } if @selectedFilterStatus.length
        filters

      makeDefaultTarget: ->
        sponsor_set: []
        suppliers: []
        due_date: []
        paid_at: []
        payout_status:
          pending_approval: false
          approved: false
          sent: false
          canceled: false
        bill_approval_status:
          unassigned: false
          assigned: false
          approved: false
          approving: false
          denied: false
        bill_payment_status:
          paid_in_full: false
          open: false
          partial_payment: false
          scheduled: false
          in_process: false
        bill_overdue: false
        bill_and_app_names_dont_match: false
        bill_and_app_amounts_dont_match: false
        payout_bank_account_missing_w9_form: false
        payout_bank_account_missing_payment_method: false
        payout_bank_account_missing_w9_or_payment_method: false

      targetPayload: ->
        payload = scopes: @scopes, q: @q, sort: @sort, target: { ...@target }
        payload

      # Workflows

      hiPendingApprovalWorkflow: ->
        @target = @getPendingApprovalTarget()
        @hiApplyFilters()

      hiApprovedWorkflow: ->
        @target = @getApprovedTarget()
        @hiApplyFilters()

      hiOverdueWorkflow: ->
        @target = @getOverdueTarget()
        @hiApplyFilters()

      hiAmountsDontMatchWorkflow: ->
        @target = @getAmountsDontMatchTarget()
        @hiApplyFilters()

      getPendingApprovalTarget: ->
        target = @makeDefaultTarget()
        target.payout_status.pending_approval = true
        target

      getApprovedTarget: ->
        target = @makeDefaultTarget()
        target.payout_status.approved = true
        target

      getOverdueTarget: ->
        target = @makeDefaultTarget()
        target.bill_overdue = true
        target

      getAmountsDontMatchTarget: ->
        target = @makeDefaultTarget()
        target.bill_and_app_amounts_dont_match = true
        target

      # Sorting

      hiAddSort: (order) ->
        return unless @sortValue.length
        @sort.push({ field: @sortValue, order })
        @sortValue = ''
        @hiApplyFilters()

      hiRemoveSort: (sort) ->
        @sort = @sort.filter((item) => item.field isnt sort.field)
        @hiApplyFilters()

      hiFlipOrder: (sort) ->
        flippedOrder = if sort.order is 'asc' then 'desc' else 'asc'
        @sort = @sort.filter (item) =>
          item.order = flippedOrder if item.field is sort.field
          item
        @hiApplyFilters()

      sortOrderIcon: (order) ->
        if order is 'asc' then 'fa-arrow-up' else 'fa-arrow-down'

      getFieldName: (field) ->
        @sortList.find((item) => item.field is field).value

export default VueOptions.vue settings
